import * as React from "react";
import type { SVGProps } from "react";
const SvgMinusCircle = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.9 3a9 9 0 1 1-4.395 16.797 1 1 0 0 0-.998 1.733 11 11 0 1 0-3.292-2.91 1 1 0 0 0 1.597-1.204A9 9 0 0 1 11.9 3.001M9 11H8v2h8v-2H9"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgMinusCircle;
